export default __webpack_public_path__ + "static/media/mc_remove_rotor_icon.24031a1e.svg";